(function () {
  'use strict';

  /**
   * @ngdoc filter
   * @name Filters.filter:profilePicture
   *
   * @description
   *
   * @param {Array} input The array to filter
   * @returns {Array} The filtered array
   *
   */
  angular
    .module('Filters')
    .filter('profilePicture', profilePicture);

  function profilePicture(Defaults) {
    return function (input, width, height) {
      var
        temp = '',
        params = {},
        paramsStr;

      width = parseInt(width);
      height = parseInt(height);
      if (input !== null && angular.isDefined(input) && angular.isDefined(input.profilePictureToken)) {
        temp = Defaults.baseUrl + '/Users/photo/' + input.profilePictureToken;
        if (!isNaN(width) && width > 0) {
          params.w = width;
        }

        if (!isNaN(height) && height > 0) {
          params.h = height;
        }

        paramsStr = $.param(params);
        if (paramsStr !== '') {
          temp += '?' + paramsStr;
        }

      }
      return temp;
    };
  }

})();
